import { isEmptyOrWhitespace, styled } from "@shoothill/core";
import { useObserver } from "mobx-react-lite";
import React, { useState } from "react";
import { InductionAdminViewModel } from "../InductionAdminViewModel";
import MaterialTable from "material-table";
import { DarwinTablePageContent } from "Globals/Styles/AppStyling";
import { formatDate, formatDateTime, formatTime } from "Utils/Format";
import { SHBox } from "Components/Box";
import { PatchedPagination } from "Components/Table/PatchedPagination";
import * as Defaults from "Globals/Defaults/TableOptions";
import { InductionAdminInspectionViewModel } from "./InductionAdminInspectionListViewModel";
import { InductionAdminInspectionListModel } from "./InductionAdminInspectionListModel";

interface IProps {
    className?: string;
    viewModel: InductionAdminViewModel;
    inductionUserId: string;
}

const InductionAdminInspectionViewBase: React.FC<IProps> = (props) => {
    const { viewModel, inductionUserId } = props;
    const [listViewModel] = useState(() => new InductionAdminInspectionViewModel(inductionUserId));
    // #region Code Behind

    const renderPage = () => {
        return (
            <DarwinTablePageContent>
                <MaterialTable
                    columns={[
                        { title: "Inspection Type", field: "inspectionTypeDisplayName" },
                        { title: "Serial/Registration/Id No.", field: "serialRegistrationNo" },
                        {
                            title: "Added by",
                            field: "createdDate",
                            render: (rowData: InductionAdminInspectionListModel) => (
                                <SHBox>
                                    <SHBox>{formatDateTime(rowData.createdDate.toString())} by</SHBox>
                                    <SHBox>{`${rowData.firstName} ${rowData.lastName}`}</SHBox>
                                </SHBox>
                            ),
                            defaultSort: "desc",
                        },
                    ]}
                    components={{
                        Pagination: PatchedPagination,
                    }}
                    options={Defaults.GetDarwinTableOptions()}
                    data={listViewModel.inspectionsListModels}
                    // onRowClick={(e, rowData) => {
                    //     listViewModel.handleRowClick(e, rowData!);
                    // }}
                    title=""
                />
            </DarwinTablePageContent>
        );
    };

    return useObserver(() => renderPage());
};

export const InductionAdminInspectionView = styled(InductionAdminInspectionViewBase)``;
